import styled from '@emotion/styled';

const RowOverlayWrapper = styled('div')({
  position: 'relative',
});

export default RowOverlayWrapper;
